module.exports = __webpack_public_path__ + "static/media/karta_klienta_profi.619e699b.png";